import React, { useState, useEffect } from "react";
import styles from "../forms.module.scss";

function ImageRadio({ imageOptions, handleChange, currentValue }) {
  const [quantity, setQuantity] = useState(0);

  const getValuePart = (val) => val.substring(val.indexOf("-") + 1).trim();

  // Get current selection info
  const currentValues = currentValue ? currentValue.split(", ") : [];

  const currentItem = currentValues.find(
    (val) => getValuePart(val) === imageOptions?.value.trim()
  );

  const isActive = Boolean(currentItem);

  useEffect(() => {
    if (currentItem) {
      const qty = parseInt(currentItem.split("-")[0], 10);
      setQuantity(isNaN(qty) ? 0 : qty);
    } else {
      setQuantity(0);
    }
  }, [currentItem]);

  function handleClick() {
    let updatedValue;

    if (isActive) {
      updatedValue = currentValues.filter(
        (val) => getValuePart(val) !== imageOptions?.value.trim()
      );
    } else {
      const newValue = `${quantity || 1}-${imageOptions?.value}`;
      updatedValue = [...currentValues, newValue];
    }

    handleChange(updatedValue.join(", "));
  }

  function handleQuantityChange(e) {
    const newQty = parseInt(e.target.value, 10) || 0;
    setQuantity(newQty);

    const updatedValue = currentValues.map((val) =>
      getValuePart(val) === imageOptions?.value.trim()
        ? `${newQty}-${imageOptions?.value}`
        : val
    );

    handleChange(updatedValue.join(", "));
  }

  return (
    <div
      className={`${isActive ? styles.activeRadio : ""} ${styles.radioImageWrapper}`}
      onClick={handleClick}
    >
      <img src={imageOptions?.image_url} alt="img" />
      <p>{imageOptions?.value}</p>
      {imageOptions?.isQuantity && (
        <input
          type="number"
          className={styles.countInput}
          min={0}
          value={quantity}
          onClick={(e) => e.stopPropagation()}
          onChange={handleQuantityChange}
        />
      )}
    </div>
  );
}

export default ImageRadio;
